import React, { useState, useEffect } from 'react'; // Μην ξεχάσεις τα imports
import './FancyBorder.css';
import fancyDesktop from '../images/HermesVI-pc.webp';
import fancyMobile from '../images/HermesVI-mb.webp';

const FancyBorder = () => {
  // Αρχική τιμή state
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 980);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 980);
    };

    // Προσθήκη event listener για να ακούει τις αλλαγές στο μέγεθος
    window.addEventListener('resize', handleResize);

    // Καθαρισμός του listener όταν ξεφορτώνει το component
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const backgroundImage = isMobile ? fancyMobile : fancyDesktop;

  return (
    <div
      className="fancyborder-image"
      // Πρόσθεσα και τα ' ' για σιγουριά
      style={{ backgroundImage: `url('${backgroundImage}')` }}
    >
      <div className="box">
        <div className="content">
          <h1>The future of aviation</h1>
          <em className={`neonText ${!isMobile ? 'animated' : ''}`}>
            Join Us Today
          </em>
        </div>
      </div>
    </div>
  );
};

export default FancyBorder;
